<script setup lang="ts">
import { computed, provide, useTemplateRef } from "vue";

import { useBoardsStore } from "@/store/boards";

import BasePlanningBoard from "./BasePlanningBoard.vue";
import { boardKey } from "./injectKeys";

defineExpose({ focus: () => void rootRef.value?.focus() });

const rootRef = useTemplateRef("root");

const board = computed(() => useBoardsStore().boardByType("solution"));
provide(boardKey, board);
</script>

<template>
  <BasePlanningBoard
    ref="root"
    :board
    :aria-label="$t('board.solution')"
    tabindex="0"
    @click="rootRef?.blur()"
  />
</template>
